import React, { useEffect, useState } from "react";
import LiveIcon from "../../../../../../../assets/images/Souvenir/live.png";
import axios from "axios";
import SuperstarAuctionNav from "../../SupestarAuctionNav/SuperstarAuctionNav";
import LoaderPost from "../../../../../../Reuseable/LoaderPost";
import ProductCardStar from "../../ProductCardStar";

const UnSoldProductList = () => {
  const [unSoldProduct, setUnSoldProduct] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    axios.get(`/api/star/unSold/auction/product/all`).then((res) => {
      setLoading(false);
      if (res.status === 200) {
        setUnSoldProduct(res.data.products);
      }
    });
  }, []);

  return (
    <>
      <SuperstarAuctionNav />

      <div className="d-flex mb-4  head-line p-3">
        <div className=" d-flex">
          <img src={LiveIcon} className=" SouvenirIcon" alt="" />
        </div>

        <div className=" d-flex text-light fw-bold mt-1 mx-3 ">Live Now</div>
      </div>

      {loading ? (
        <LoaderPost />
      ) : (
        <ProductCardStar data={unSoldProduct} noBidder="true" unsold="true" />
      )}
    </>
  );
};

export default UnSoldProductList;
